import { render, staticRenderFns } from "./dangerousGoodsListForm.vue?vue&type=template&id=bc8ce4da"
import script from "./dangerousGoodsListForm.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports